import { FirebaseAuthRepository } from "./infrastructure/firebase/FirebaseAuthRepository";
import { FirestoreUserProfileRepository } from "./infrastructure/firebase/FirestoreUserProfileRepository";
import { FirebaseServiceRepository } from "./infrastructure/firebase/FirebaseServiceRepository";
import { FirebaseCommentsRepository } from "./infrastructure/firebase/FirebaseCommentsRepository";
import { FirebaseFavoritesRepository } from "./infrastructure/firebase/FirebaseFavoritesRepository";
import { FirebaseRatingsRepository } from "./infrastructure/firebase/FirebaseRatingsRepository";
import { FirebaseReportsRepository } from "./infrastructure/firebase/FirebaseReportsRepository";
import { FirebaseContactRepository } from "./infrastructure/firebase/FirebaseContactRepository";
import { FirebasePhoneOTPRepository } from "./infrastructure/firebase/FirebasePhoneOTPRepository";
import { FirebaseRateLimitRepository } from "./infrastructure/firebase/FirebaseRateLimitRepository";
import { FirebaseSettingsRepository } from "./infrastructure/firebase/FirebaseSettingsRepository";
import { FirebaseUsernameGenerator } from "./infrastructure/firebase/FirebaseUsernameGenerator";
import { FirebaseProfileImageStorage } from "./infrastructure/firebase/FirebaseProfileImageStorage";
import { FirebaseServiceImageStorage } from "./infrastructure/firebase/FirebaseServiceImageStorage";
import { FirebaseAccountDeletionRepository } from "./infrastructure/firebase/FirebaseAccountDeletionRepository";
import { FirebaseAdminRepository } from "./infrastructure/firebase/FirebaseAdminRepository";
import { getFirebaseApp } from "./infrastructure/firebase/config";
let liveContainer = null;
export function createLiveContainer(options) {
    if (liveContainer)
        return liveContainer;
    getFirebaseApp(options);
    liveContainer = {
        authRepository: new FirebaseAuthRepository(),
        userProfileRepository: new FirestoreUserProfileRepository(),
        serviceRepository: new FirebaseServiceRepository(),
        commentsRepository: new FirebaseCommentsRepository(),
        favoritesRepository: new FirebaseFavoritesRepository(),
        ratingsRepository: new FirebaseRatingsRepository(),
        reportsRepository: new FirebaseReportsRepository(),
        contactRepository: new FirebaseContactRepository(),
        phoneOTPRepository: new FirebasePhoneOTPRepository(),
        rateLimitRepository: new FirebaseRateLimitRepository(),
        settingsRepository: new FirebaseSettingsRepository(),
        usernameGenerator: new FirebaseUsernameGenerator(),
        profileImageStorage: new FirebaseProfileImageStorage(),
        serviceImageStorage: new FirebaseServiceImageStorage(),
        accountDeletionRepository: new FirebaseAccountDeletionRepository(),
        adminRepository: new FirebaseAdminRepository(),
    };
    return liveContainer;
}
//# sourceMappingURL=container.js.map